import { render, staticRenderFns } from "./searchPlus.vue?vue&type=template&id=4fb0bc2c&scoped=true&"
import script from "./searchPlus.vue?vue&type=script&lang=js&"
export * from "./searchPlus.vue?vue&type=script&lang=js&"
import style0 from "./searchPlus.vue?vue&type=style&index=0&id=4fb0bc2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0bc2c",
  null
  
)

export default component.exports